import React from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as multiCurrencyActions from '../../multiCurrency/actions';
import * as supplierIntegrationsActions from '../../supplierIntegrations/actions';
import * as actions from '../actions';
import * as selectors from '../selectors';

import Form from './Form';

const ModalForm = ({
    canModifyAdvancedFeatures,
    canViewAdvancedFeatures,
    fetchCurrencies,
    fetchSupplierIntegrations,
    fetchTemplates,
    isModalFormOpen,
    selectedProjectId,
    setModalFormOpenStatus,
}) => {
    const { t } = useTranslation();

    const handleOnClose = () => setModalFormOpenStatus(false);

    const onEnter = () => {
        fetchCurrencies();
        fetchSupplierIntegrations();
        fetchTemplates();
    };

    return (
        <Dialog
            onClose={handleOnClose}
            onEnter={onEnter}
            open={isModalFormOpen}
            size="md"
            title={t('Project settings')}
        >
            <Form
                canModifyAdvancedFeatures={canModifyAdvancedFeatures}
                canViewAdvancedFeatures={canViewAdvancedFeatures}
                onClose={handleOnClose}
                selectedProjectId={selectedProjectId}
            />
        </Dialog>
    );
};

ModalForm.propTypes = {
    canModifyAdvancedFeatures: PropTypes.bool,
    canViewAdvancedFeatures: PropTypes.bool,
    fetchCurrencies: PropTypes.func,
    fetchSupplierIntegrations: PropTypes.func,
    fetchTemplates: PropTypes.func,
    isModalFormOpen: PropTypes.bool,
    selectedProjectId: PropTypes.string,
    setModalFormOpenStatus: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    isModalFormOpen: selectors.getIsModalFormOpen,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCurrencies: () => dispatch(multiCurrencyActions.filterItems()),
    fetchSupplierIntegrations: () =>
        dispatch(supplierIntegrationsActions.fetchIntegrations()),
    fetchTemplates: () => dispatch(actions.fetchTemplates()),
    setModalFormOpenStatus: (value) =>
        dispatch(actions.setModalFormOpenStatus(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalForm);
